import { API_BASE_URL } from "../config";

export function buildUrl(path) {
	if (typeof path !== "string") {
		throw new TypeError("api: path deve essere una stringa");
	}
	if (/^https?:\/\//i.test(path)) {
		return path;
	}
	const normalized = path.startsWith("/") ? path : `/${path}`;
	return `${API_BASE_URL}${normalized}`;
}

function isPlainObject(value) {
	return value && typeof value === "object" && !Array.isArray(value) && !(value instanceof FormData);
}

export class ApiError extends Error {
	constructor(message, { status = 0, body = null, url = null, cause = null } = {}) {
		super(message);
		this.name = "ApiError";
		this.status = status;
		this.body = body;
		this.url = url;
		this.isNetworkError = status === 0;
		if (cause) this.cause = cause;
	}
}

async function parseBody(response) {
	const contentType = response.headers.get("content-type") || "";
	if (contentType.includes("application/json")) {
		try {
			return await response.json();
		} catch {
			return null;
		}
	}
	try {
		return await response.text();
	} catch {
		return null;
	}
}

export async function apiFetch(path, options = {}) {
	const { headers: customHeaders, body, json, ...rest } = options;
	const url = buildUrl(path);

	const headers = new Headers(customHeaders || {});
	let finalBody = body;

	if (json !== undefined) {
		if (!headers.has("Content-Type")) {
			headers.set("Content-Type", "application/json");
		}
		finalBody = JSON.stringify(json);
	} else if (isPlainObject(body) && !headers.has("Content-Type")) {
		headers.set("Content-Type", "application/json");
		finalBody = JSON.stringify(body);
	}

	let response;
	try {
		response = await fetch(url, { ...rest, headers, body: finalBody });
	} catch (cause) {
		throw new ApiError(`Errore di rete su ${url}`, { url, cause });
	}

	const parsed = await parseBody(response);

	if (!response.ok) {
		const message =
			(parsed && (parsed.message || parsed.error)) ||
			(typeof parsed === "string" ? parsed : null) ||
			`HTTP ${response.status}`;
		throw new ApiError(message, { status: response.status, body: parsed, url });
	}

	return parsed;
}

export const api = {
	get: (path, options = {}) => apiFetch(path, { ...options, method: "GET" }),
	post: (path, jsonBody, options = {}) => apiFetch(path, { ...options, method: "POST", json: jsonBody }),
	put: (path, jsonBody, options = {}) => apiFetch(path, { ...options, method: "PUT", json: jsonBody }),
	del: (path, options = {}) => apiFetch(path, { ...options, method: "DELETE" }),
	postForm: (path, formData, options = {}) => apiFetch(path, { ...options, method: "POST", body: formData }),
};
